import React from 'react';

import useChapterIntroductionTextModal from '@HOOKS/store/modals/useChapterIntroductionTextModal';
import { useUpdateChapter } from '@SERVICES';

import IntroductionTextModal from '@MODALS/IntroductionTextModal';

function ChapterIntroductionTextModal() {
    const {
        state: { data: modalParams, isOpen },
        actions: chapterIntroductionTextModalActions,
    } = useChapterIntroductionTextModal(() => true);

    const [
        updateChapter,
        {
            isLoading: isSaving,
            isSuccess: isSaveSuccess,
            isError: isSaveError,
        },
    ] = useUpdateChapter();

    if (!modalParams) return null;

    const { chapterData, canEditDocument } = modalParams;

    const handleSave = (content: string) => {
        updateChapter({
            id: chapterData.id,
            documentId: chapterData.document.id,
            name: chapterData.name,
            body: content,
            isMandatory: chapterData.isMandatory,
            image: chapterData.image,
        });
    };

    const handleClose = () => {
        chapterIntroductionTextModalActions.close();
    };

    const config = {
        title: 'Chapter Introduction Text',
        subtitle: 'This text will appear at the top of the chapter, before all sections',
        successMessage: 'Chapter introduction text saved successfully',
        errorMessage: 'Failed to save chapter introduction text',
    };

    return (
        <IntroductionTextModal
            isOpen={isOpen}
            onClose={handleClose}
            initialValue={chapterData.introductionText.body || ''}
            canEdit={canEditDocument}
            config={config}
            onSave={handleSave}
            isSaving={isSaving}
            saveError={isSaveError}
            saveSuccess={isSaveSuccess}
        />
    );
}

export default ChapterIntroductionTextModal; 